import React, {useEffect, useState} from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Page, { IButton } from './Page';
import { H4Styled, Spacer, InnerContainer } from '../../styledComponents';
import { authUser } from '../../actions/actions';
import { LoadingModal } from '../modals';
import {handleUserKeyPress} from "../../helpers";

interface IProps {
	onContinue: () => void;
	showErrorScreen: (code:string) => void;
	shadow: boolean;
	appName: string;
	authRequestId?: string;
	smsSent:boolean
	setSmsSent: (code: boolean) => void;
	test?: boolean;
}

function StartScreen(props: IProps) {
	const { onContinue, appName, shadow, authRequestId, showErrorScreen, smsSent, setSmsSent, test  } = props;
	const [loading, setLoading] = useState(false);
	const { t } = useTranslation();

	useEffect(() => {
		window.addEventListener('keydown', (e)=>handleUserKeyPress(e, onContinue));

		return () => {
			window.removeEventListener('keydown', (e)=>handleUserKeyPress(e, onContinue));
		};
	}, []);
	const handleContinue = async () => {
		setLoading(true);
		if(authRequestId && !smsSent) {
			const response = await authUser({authRequestId, test});
			if (response?.ok) {
				setSmsSent(true);
				setLoading(false);
				onContinue();
			} else {
				showErrorScreen(response?.statusCode.toString())
			}
		} else if(smsSent) {
			setLoading(false);
			onContinue();
		}

	};
	const buttons: IButton[] = [
		{
			label: t('continue'),
			onClick: () => handleContinue()
		}
	];
	return (
		<Page
			title={
				appName ? (
					<Trans t={t} i18nKey="use_basiq_to_connect_your_accounts" values={{ name: appName }} components={{ bold: <strong /> }} />
				) : (
					<Trans t={t} i18nKey="we_use_basiq_to_connect_your_accounts" components={{ bold: <strong /> }} />
				)
			}
			shadow={shadow}
			buttons={buttons}
		>
			<InnerContainer>
				<Spacer />
				<H4Styled>{t('to_do_this_we_will_ask_you_to')}</H4Styled>
				<ul>
					<li>
						<Trans t={t} i18nKey="verify_your_mobile_number_bold" components={{ bold: <strong /> }} />
					</li>
					<li>
						<Trans t={t} i18nKey="consent_to_share_your_data_with_us" components={{ bold: <strong /> }} />
					</li>
					<li>
						<Trans t={t} i18nKey="share_your_financial_data" components={{ bold: <strong /> }} />
					</li>
				</ul>
				<H4Styled>{t('things_you_should_know')}</H4Styled>
				<ul>
					<li>{t('we_dont_share_your_data_without_your_consent')}</li>
					<li>{t('you_can_easily_stop_sharing_your_data_at_any_time')}</li>
					<li>{t('you_can_choose_to_delete_shared_data_when_we_no_longer_need_it')}</li>
				</ul>
				<Spacer />
				<span>
					<>
					{t('by_proceeding_you_agree_to_the')}{' '}
						<a href="https://docs.basiq.io/en/articles/415750-basiq-terms-of-service" rel="noreferrer" target="_blank">{t('terms_of_service')}</a> {t('and')}{' '}
						<a href="https://docs.basiq.io/en/articles/382581-basiq-privacy-policy" rel="noreferrer" target="_blank">{t('privacy_notice')}</a>
					</>
				</span>
				<LoadingModal isOpen={loading} />
			</InnerContainer>
		</Page>
	);
}

export default StartScreen;
